import { DEV_MODE } from '@/config/dev-mode';
import { formatConsoleMessage } from '@/composables/functions';

export const postToApp = (messageData) => {
  if (!window.ReactNativeWebView) return false;

  window.ReactNativeWebView.postMessage(JSON.stringify(messageData));
  return true;
};

export const useRnBridge = () => {
  /** 앱으로 메시지 전송 */
  const sendMessageToApp = ({ action, message, route, sku, payload }) => {
    const sent = postToApp({
      action,
      payload: payload ?? {
        message,
        route,
        ...(sku ? { sku } : {}),
      },
    });

    if (!sent) {
      console.warn('ReactNativeWebView not found');
    }
  };

  /** 디버깅 핸들러 (콘솔 출력 + RN 메시지 전달) */
  const debuggingHandler = ({ action, message }) => {
    if (DEV_MODE) {
      switch (action) {
        case 'debug':
          console.log(formatConsoleMessage(message));
          break;
        case 'error':
          console.error(formatConsoleMessage(message));
          break;
        default:
          console.warn(`Unknown debug action: ${action}`);
          break;
      }
    }

    sendMessageToApp({ action, message });
  };

  return {
    /** 앱으로 메시지 전송 */
    sendMessageToApp,
    /** 디버깅 핸들러 (콘솔 출력 + RN 메시지 전달) */
    debuggingHandler,
  }
}
